import { get } from 'lodash';
import { ANTRAGS_FORMULAREN } from '../../../../../lib/constants/constant';
import { assignIdsToStruc } from '../../../../../utils/helper';
import { TreeStructureAbschlussEmob } from './emob/TreeStructureAbschlussEmob';
import { TreeStructureAbschlussKreativ } from './kreativwirtschaft/TreeStructureAbschlussKreativ';
import { TreeStructureAbschlussMesse } from './messefoerderung/TreeStructureAbschlussMesse';
import { TreeStructureAbschlussStartUp } from './startup-projekte/TreeStructureAbschlussStartUp';

// import schemas
import Schema from '../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

export const TreeStructureAbschlussbericht = (application: any) => {
	let berichtTreeStruc: any = [];
	const antragFormular = get(application, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path, '');

	switch (antragFormular) {
		case ANTRAGS_FORMULAREN.EmobInvest:
		case ANTRAGS_FORMULAREN.EmobFundE:
			berichtTreeStruc = TreeStructureAbschlussEmob(application);
			break;
		case ANTRAGS_FORMULAREN.Messefoerderung:
			berichtTreeStruc = TreeStructureAbschlussMesse(application);
			break;
		case ANTRAGS_FORMULAREN.StartUpProjekte:
			berichtTreeStruc = TreeStructureAbschlussStartUp();
			break;
		case ANTRAGS_FORMULAREN.Kreativwirtschaft:
			berichtTreeStruc = TreeStructureAbschlussKreativ();
			break;
		default:
			berichtTreeStruc = TreeStructureAbschlussEmob(application);
			break;
	}

	return assignIdsToStruc(berichtTreeStruc);
};
